import React from 'react';
const ArrowIcon = ({ className })=>{
    return /*#__PURE__*/ React.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "8",
        height: "8",
        fill: "none",
        viewBox: "0 0 8 8"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M8 0v8H0l8-8z"
    }));
};
ArrowIcon.displayName = 'ArrowIcon';
export default ArrowIcon;

//# sourceMappingURL=ArrowIcon.js.map